// extracted by mini-css-extract-plugin
export default {"fixedHorizontalScrollTable":"styles_fixedHorizontalScrollTable__8fzrb"};